import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
/*
import FormDrawer from "components/__new/common/form-drawer";
import PinInput from 'react-pin-input';
import { toast } from "react-toastify";
import { ButtonLoader } from "./form";
import Maybe from "./Maybe";
import PageContent from "./PageContent";
import ResetAccessPin from "components/__new/common/access-pin/ResetAccessPin";
import CreateAccessPin from "components/__new/common/access-pin/CreateAccessPin";
import useLoginInfo from "hooks/useLoginInfo";
*/
import { toast } from "react-toastify";
import PinModal from "components/__new/common/PinModal";
import CreateAccessPin from "./CreateAccessPin";
import useLoginInfo from "hooks/useLoginInfo";
import useAccessPinStatus from "hooks/useAccessPinStatus";
import * as walletAction from "store/entities/wallet/action";


export const RequestAccessPin = (props) => {
    const {target, title, description, showForgotPin, footnote, pin, submit, loading, modalLoading, isOpenPin, setIsOpenPin} = props;
    const createAccessPinRef = useRef();
    
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const {getAccessPinStatus} = useAccessPinStatus();
    const {dashboardLoading, dashboard} = useSelector((s) => s.entities.wallet);
    const [isAccessPinSet, setIsAccessPinSet] = useState(null);
    
    const getDashboard = () => {
        if(!dashboardLoading && (Object.keys(dashboard).length === 0 || dashboard.status !== "success")){
            dispatch(walletAction.getDashboardSilent(userInfo.token));
        }
    }
    
    useEffect(() => {
        getDashboard();
        // eslint-disable-next-line
    }, [isOpenPin]);
    
    
    useEffect(() => {
        if (isOpenPin === true){
            if (dashboard?.status === "success"){
                const hasAccessPin = getAccessPinStatus(dashboard);
                setIsAccessPinSet(hasAccessPin);
                
                if (hasAccessPin === null || hasAccessPin === false){
                    createAccessPinRef.current?.initiateCreateAccessPin();
                    setIsOpenPin(false);
                }
                else if (hasAccessPin === true){
                    setIsOpenPin(true);
                }
            }
            else{
                toast.error("An error occurred, please try again later");
                // toast.error("Unable to fetch access information, please try again later");
            }
        }
        // eslint-disable-next-line
    }, [isOpenPin, dashboard]);
    
    
    return (
        <>
        
            {dashboardLoading === false && dashboard?.status === "success" &&
                <>
                
                    {(isAccessPinSet === null || isAccessPinSet === false) &&
                        <CreateAccessPin
                            ref={createAccessPinRef}
                            oncomplete={() => {
                                setIsOpenPin(true);
                            }}
                        />
                    }
                
                    {(isAccessPinSet === true) &&
                        <PinModal
                            target={target}
                            title={title}
                            description={description}
                            showForgotPin={showForgotPin}
                            footnote={footnote}
                            pin={(e) => pin(e)}
                            submit={(e) => submit(e)}
                            loading={loading}
                            modalLoading={modalLoading}
                            isOpenPin={isOpenPin}
                            setIsOpenPin={setIsOpenPin}
                        />
                    }
                    
                </>
            }
        
        </>
    )
}

export default RequestAccessPin;